import { memo, useEffect, useState, useCallback } from "react";
import Form from "../../components/Form";
import {
    getOwners,
    getInspectors,
} from "../../api";
import { useSnackbar } from "../../utils/index.js";
import useSelectStyles from "../../components/styles/Select";
import { Box, Typography } from "@mui/material";
import Spinner from "../../components/Spinner.js";
import MilkRecordingForm from "../../components/forms/MilkRecordingForm.js";


const CreateMilkRecording = () => {
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [fetchedInspectors, setFetchedInspectors] = useState([]);
    const [inspectorsDropdownValues, setInspectorsDropdownValues] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);
    const [ownerDateSelected, setOwnerDateSelected] = useState(false);
    const [selectedOwner, setSelectedOwner] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [defaultInspector, setDefaultInspector] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);

    const classes = useSelectStyles();
    const { error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            setIsLoading(true);
            try {
                const { owners } = await getOwners();
                setFetchedOwners(owners)
                setOwnersDropdownValues(owners.map((owner) => ({
                    value: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                    text: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`
                })));
                const { inspectors } = await getInspectors();
                setFetchedInspectors(inspectors);
                setInspectorsDropdownValues(inspectors.map((inspector) => ({
                    value: `${inspector?.lastName} ${inspector?.firstName}`,
                    text: `${inspector?.lastName} ${inspector?.firstName}`
                })));
            } catch (err) {
                error(err);
            }
            setIsLoading(false);
        })

    useEffect(() => {
        fetchData();
    }, []);

    const selectOwnerFormContent = [
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Εκτροφή",
            required: true,
        },
        {
            customType: "date-picker",
            id: "testDate",
            type: "desktop",
            label: "Ημ/νια Ελέγχου",
            width: "595px",
            background: "third",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Επόμενο"
        },
    ];

    const submitOwnerSelect = (values) => {
        const selectedOwnerObj = fetchedOwners.find((owner) =>
            `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.owner
        );
        setSelectedOwner(selectedOwnerObj);
        setDefaultInspector(fetchedInspectors.find((inspector) =>
            inspector._id = selectedOwnerObj.inspector
        ));
        setSelectedDate(values.testDate)
        setOwnerDateSelected(true);
    };

    return (
        <>
            <Spinner open={isLoading} />
            {!ownerDateSelected && (
                <Box className={classes.outerBox}>
                    <Box container flexDirection="column" className={classes.innerBox}>

                        <Typography variant="h5" sx={{ margin: "1rem" }}>
                            {console.log(fetchedOwners)}
                            Επιλέξτε την Εκτροφή που σας ενδιαφέρει:
                        </Typography>
                        <Form
                            content={selectOwnerFormContent}
                            toResetForm={false}
                            onSubmit={submitOwnerSelect}
                        />
                    </Box>
                </Box>
            )}
            {ownerDateSelected && (
                <MilkRecordingForm
                    isCreate={true}
                    ownersDropdownValues={ownersDropdownValues}
                    selectedOwner={selectedOwner}
                    selectedDate={selectedDate}
                    inspectorsDropdownValues={inspectorsDropdownValues}
                    defaultInspector={defaultInspector}
                    setOwnerDateSelected={setOwnerDateSelected}
                    fetchedInspectors={fetchedInspectors}
                />
            )}
        </>
    )
}

export default memo(CreateMilkRecording)